import deDE from '../translations/de-DE.json' with { type: "json" };
import enGB from '../translations/en-GB.json' with { type: "json" };
import esES from '../translations/es-ES.json' with { type: "json" };
import frFR from '../translations/fr-FR.json' with { type: "json" };
import itIT from '../translations/it-IT.json' with { type: "json" };
import jaJP from '../translations/ja-JP.json' with { type: "json" };
import koKR from '../translations/ko-KR.json' with { type: "json" };
import nlNL from '../translations/nl-NL.json' with { type: "json" };
import plPL from '../translations/pl-PL.json' with { type: "json" };
import ptPT from '../translations/pt-PT.json' with { type: "json" };

/**
 *
 * @type {Map<string, any>}
 */
const dictionary = new Map();
dictionary.set('de-DE', deDE);
dictionary.set('en-GB', enGB);
dictionary.set('es-ES', esES);
dictionary.set('fr-FR', frFR);
dictionary.set('it-IT', itIT);
dictionary.set('ja-JP', jaJP);
dictionary.set('ko-KR', koKR);
dictionary.set('nl-NL', nlNL);
dictionary.set('pl-PL', plPL);
dictionary.set('pt-PT', ptPT);

/**
 *
 * @param {string} language
 * @returns {boolean}
 */
export const dictionaryContainsLanguage = (language) => {
  return dictionary.has(language);
}

/**
 *
 * @param {string} language
 * @returns {*}
 */
export const getDictionary = (language) => {
  let currentDictionary = null;

  if (dictionary.has(language)) {
    currentDictionary = dictionary.get(language);
  }

  if (!currentDictionary) {
    currentDictionary = dictionary.get('en-GB');
  }

  return currentDictionary;
};
